import { useEffect, useState } from 'react'
import { Alert, Badge, Button, Col, FloatingLabel, Form } from 'react-bootstrap'
import Card from 'react-bootstrap/esm/Card'
import Row from 'react-bootstrap/esm/Row'
import ClientesDataService from '../../../Services/Catalogos/Clientes.Services'
import ConsultasDataService from '../../../Services/Consultas/Consultas.Services'
import IClientes from '../../../Interfaces/Catalogos/IClientes'
import { set } from 'cypress/types/lodash'

export interface IPedimentoPdfProps {}

export default function PedimentoPdf(props: IPedimentoPdfProps) {
  const [UserId, setUserId] = useState(() => {
    const stickyValue = window.localStorage.getItem('UserId')
    return stickyValue !== null ? JSON.parse(stickyValue) : 0
  })
  const [Referencia, setReferencia] = useState('')
  const [Folio, setFolio] = useState('')
  const [Pedimento, setPedimento] = useState('')
  const [Patente, setPatente] = useState('3636')
  const [Aduana, setAduana] = useState('240')
  const [Clientes, setClientes] = useState<Array<IClientes>>()
  const [Cliente, setCliente] = useState(0)
  const [PdfContent, setPdfContent] = useState<any>()
  const [DisableFields, setDisabbleFields] = useState(true)

  const submitForm = () => {
    if (Referencia === '' && Folio === '' && Pedimento === '') {
      alert('Para poder continuar debe proporcionar algun dato de busqueda')
      return
    }
    ConsultasDataService.getPedimentoContent(
      Referencia,
      Folio,
      Pedimento,
      Cliente.toString(),
      Patente,
      Aduana
    )
      .then((response: any) => {
        if (response.status === 200) {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)
          setPdfContent(url)
        }
      })
      .catch((e: Error) => {
        alert('No se encontraron resultados')
      })
  }

  useEffect(() => {
    ClientesDataService.getAllClientes(parseInt(UserId))
      .then((response) => {
        setClientes(response.data)
        setReferencia('')
        setFolio('')
      })
      .catch((e: Error) => {})
  }, [])

  useEffect(() => {
    setDisabbleFields(Pedimento.length > 0 ? false : true)
    if (Pedimento.length > 0) {
      setReferencia('')
      setFolio('')
    }
  }, [Pedimento])

  useEffect(() => {
    if (Folio.length > 0) {
      setReferencia('')
      setPedimento('')
    }
  }, [Folio])

  useEffect(() => {
    if (Referencia.length > 0) {
      setFolio('')
      setPedimento('')
    }
  }, [Referencia])

  return (
    <div style={{ paddingTop: '20px' }}>
      <Form>
        <Alert style={{ padding: '8px' }}>
          <Row>
            <Col xs={1}></Col>
            <Col xs={3} style={{ paddingTop: '3px' }}>
              <Form.Control
                as="select"
                onChange={(e) => {
                  setCliente(parseInt(e.target.value))
                }}
                className="form-select form-select-sm"
                style={{ height: '45px' }}
              >
                <option value="0">-SELECCIONE-</option>
                {Clientes
                  ? Clientes.map((c) => {
                      return c.agrupado === 1 ? (
                        <option value={c.sClave}>{c.sRazonSocial}</option>
                      ) : (
                        ''
                      )
                    })
                  : null}
              </Form.Control>
            </Col>
            <Col xs={2}>
              <FloatingLabel controlId="floatingInput" label="Referencia">
                <Form.Control
                  type="text"
                  placeholder="Referencia"
                  value={Referencia}
                  onChange={(e) => setReferencia(e.target.value)}
                  style={{ height: '50px' }}
                />
              </FloatingLabel>
            </Col>
            <Col xs={1}>
              <FloatingLabel controlId="floatingSelect" label="Patente">
                <Form.Select
                  aria-label="Patente"
                  onChange={(e) => setPatente(e.target.value)}
                  style={{ height: '54px' }}
                  disabled={DisableFields}
                >
                  <option value="3636">3636</option>
                  <option value="1631">1631</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col xs={1}>
              <FloatingLabel controlId="floatingSelect" label="Aduana">
                <Form.Select
                  aria-label="Aduana"
                  onChange={(e) => setAduana(e.target.value)}
                  style={{ height: '54px' }}
                  disabled={DisableFields}
                >
                  <option value="240">240 - Laredo</option>
                  <option value="800">800 - Colombia</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col xs={1}>
              <FloatingLabel controlId="floatingInput" label="Pedimento">
                <Form.Control
                  type="text"
                  placeholder="Pedimento"
                  value={Pedimento}
                  onChange={(e) => setPedimento(e.target.value)}
                  style={{ height: '50px' }}
                />
              </FloatingLabel>
            </Col>
            <Col xs={1}>
              <FloatingLabel controlId="floatingInput" label="Folio">
                <Form.Control
                  type="text"
                  placeholder="Folio"
                  value={Folio}
                  onChange={(e) => setFolio(e.target.value)}
                  style={{ height: '50px' }}
                />
              </FloatingLabel>
            </Col>
            <Col xs={1} style={{ textAlign: 'right', paddingTop: '8px' }}>
              <Button
                variant="primary"
                onClick={() => {
                  submitForm()
                }}
              >
                Buscar
              </Button>
            </Col>
          </Row>
        </Alert>
      </Form>
      <Card>
        <object
          style={{ width: '100%', height: '100vh' }}
          data={PdfContent}
          type="application/pdf"
        >
          {' '}
        </object>
      </Card>
    </div>
  )
}
